import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/american/arrow_back.svg'
import _imports_1 from '@/assets/american/american-logo.svg'
import _imports_2 from '@/assets/american/american-logo-laptop.svg'
import _imports_3 from '@/assets/navigation/icon-game.svg'
import _imports_4 from '@/assets/navigation/icon-play.svg'
import _imports_5 from '@/assets/navigation/icon-news.svg'


const _withScopeId = n => (_pushScopeId("data-v-defe2486"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav-wrapper" }
const _hoisted_2 = { class: "nav-button-group-mobile" }
const _hoisted_3 = { class: "aa-back-button-group-mobile" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  height: "24",
  alt: "back button"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  height: "32",
  alt: "logo"
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "nav-button-group" }
const _hoisted_9 = { class: "aa-back-button-group" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  height: "24",
  alt: "back button"
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  height: "42",
  alt: "logo"
}, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "nav-item-image"
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "nav-item-image"
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "nav-item-image"
}, null, -1))
const _hoisted_17 = { class: "version" }
const _hoisted_18 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("nav", {
      style: _normalizeStyle(_ctx.cssProps)
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              type: "button",
              class: "icon-button aa-back-button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.window.history.back()))
            }, _hoisted_5),
            _createElementVNode("button", {
              type: "button",
              class: "icon-button aa-back-logo",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.window.history.back()))
            }, _hoisted_7)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              type: "button",
              class: "icon-button aa-back-button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.window.history.back()))
            }, _hoisted_11),
            _createElementVNode("button", {
              type: "button",
              class: "icon-button aa-back-logo",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.window.history.back()))
            }, _hoisted_13)
          ])
        ])
      ])
    ], 4),
    _createElementVNode("div", {
      onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.disableMainOverlay && _ctx.disableMainOverlay(...args)), ["stop"])),
      class: _normalizeClass([
        'overlay',
        _ctx.overlayMainVisible ? '' : 'hidden',
        _ctx.overlayMainTriggerAnimation ? 'active' : '',
      ])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass([
          'overlay-content',
          _ctx.overlayMainTriggerAnimation ? 'active' : '',
        ])
      }, [
        _createElementVNode("button", {
          onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.disableMainOverlayAndNavigate('Games')), ["stop"]))
        }, [
          _hoisted_14,
          _createTextVNode(" " + _toDisplayString(_ctx.t('games.games')), 1)
        ]),
        _createElementVNode("button", {
          onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.disableMainOverlayAndNavigate('Streams')), ["stop"]))
        }, [
          _hoisted_15,
          _createTextVNode(" " + _toDisplayString(_ctx.t('streams.streams')), 1)
        ]),
        (_ctx.hideShop != 'true')
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.disableMainOverlayAndNavigate('Shop')), ["stop"]))
            }, [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fa', 'shopping-cart'],
                size: "lg",
                class: "white nav-item-image"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.t('shop.shop')), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.disableMainOverlayAndNavigate('News')), ["stop"]))
        }, [
          _hoisted_16,
          _createTextVNode(" " + _toDisplayString(_ctx.t('news.news')), 1)
        ]),
        _createElementVNode("p", _hoisted_17, "Version: " + _toDisplayString(_ctx.version) + "/" + _toDisplayString(_ctx.apiVersion), 1)
      ], 2)
    ], 2),
    _createElementVNode("div", {
      onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.disableMoreOverlay && _ctx.disableMoreOverlay(...args)), ["stop"])),
      class: _normalizeClass([
        'more-overlay',
        _ctx.overlayMoreVisible ? '' : 'hidden',
        _ctx.overlayMoreTriggerAnimation ? 'active' : '',
      ])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass([
          'more-overlay-content',
          _ctx.overlayMoreTriggerAnimation ? 'active' : '',
        ])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (name, locale) => {
          return (_openBlock(), _createElementBlock("button", {
            key: `locale-${locale}`,
            onClick: _withModifiers(($event: any) => (_ctx.disableMoreOverlayAndSetLanguage(locale)), ["stop"])
          }, _toDisplayString(name), 9, _hoisted_18))
        }), 128))
      ], 2)
    ], 2)
  ]))
}